/**
 * Suzy Love — featured product list horizontal scroll arrows
 */
(function () {
  function initWrap(wrap) {
    const track = wrap.querySelector('[data-featured-scroller]');
    const prev = wrap.querySelector('[data-featured-prev]');
    const next = wrap.querySelector('[data-featured-next]');
    if (!track || !prev || !next) return;

    const getStep = () => {
      const item = track.querySelector('.product-list-featured__item');
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 5;
      if (item) return item.getBoundingClientRect().width + gap;
      return Math.max(track.clientWidth * 0.75, 200);
    };

    const update = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const canScroll = maxScroll > 4;
      wrap.classList.toggle('product-list-featured-wrap--scrollable', canScroll);
      prev.disabled = !canScroll || track.scrollLeft <= 4;
      next.disabled = !canScroll || track.scrollLeft >= maxScroll - 4;
      prev.setAttribute('aria-hidden', canScroll ? 'false' : 'true');
      next.setAttribute('aria-hidden', canScroll ? 'false' : 'true');
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(update).observe(track);
    }

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-featured-wrap]').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const wrap = event.target.querySelector?.('[data-featured-wrap]');
    if (wrap) initWrap(wrap);
  });
})();
